import { Button, Grid, List, ListItem, ListItemButton, TextField, Typography } from "@mui/material";
import AdminSidebar from "./Sidebar";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Add, Close } from "@mui/icons-material";
export default function Pages() {

    const [pages, setpages] = useState(['Home', 'List Your Business', 'About Us', 'Contact Us']);

    const [data, setdata] = useState();
    const [headings, setheadings] = useState([]);
    const [currentPage, setcurrentPage] = useState('Home');
    var url = `http://localhost:${process.env?.PORT || 3000}/`;
    function fetchHeadings(pageName = 'Home') {
        axios.post(url + 'fetchHeadings', {
            PageName: pageName
        }).then((succ) => {
            setdata(succ.data);
            setheadings(...headings)
            setheadings(succ.data.Headings);
            // setheadings([...headings, succ.data.Headings]);
            console.log(succ.data.Headings)
        });
    }

    useEffect(() => {
        fetchHeadings();
    }, [])

    // function saveChanges(e) {
    //     e.preventDefault();
    //     var data = new FormData(e.currentTarget);
    //     var dta = [];
    //     headings.map((row) => {
    //         dta.push(data.get(row));
    //     })
    // }

    // function saveChanges(e) {
    //     e.preventDefault();

    //     const formData = new FormData(e.currentTarget);
    //     const obj = Object.fromEntries(formData.entries());

    //     const headingsMap = {};

    //     Object.keys(obj).forEach((key) => {
    //         const match = key.match(/headings\[(.+?)\]\[(.+?)\]/);
    //         if (!match) return;

    //         const no = match[1];     // row.no
    //         const field = match[2];  // content | fontfamily | fontweight | no

    //         if (!headingsMap[no]) {
    //             headingsMap[no] = {};
    //         }

    //         headingsMap[no][field] = obj[key];
    //     });

    //     const finalHeadings = Object.values(headingsMap);
    //     console.log(finalHeadings);
    //     axios.post(url + 'saveChangesToContent', {
    //         PageName: 'Home',
    //         Headings: finalHeadings
    //     }).then((succ) => {
    //         fetch();
    //         alert('changed')
    //     })
    // }

    function saveChanges(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        // var dta = [];
        // headings.map((row) => {
        //     dta.push({
        //         no: row.no,
        //         content: data.get(`heading${row.no}`)
        //     });
        // })
        // console.log(dta);
        axios.post(url + 'saveChangesToContent', {
            PageName: currentPage,
            Headings: headings
        }).then((succ) => {
            fetchHeadings();
            alert('changed')
        })
    }

    function changePage(name) {
        setcurrentPage(name);
        fetchHeadings(name);
    }

    function handleChange(no, value) {
        setheadings((prev) =>
            prev.map((row) =>
                row.no === no ? { ...row, content: value } : row
            )
        );
    }

    return (
        <>

            <Grid container sx={{ m: 0, width: '100%' }}>
                <AdminSidebar />
                <Grid container size={{ lg: 10 }} alignItems={'center'} justifyContent={'space-around'}>
                    <Grid bgcolor={'#0F1536'} borderRadius={2} size={{ lg: 4 }} >
                        <Typography variant="h6" p={2} color="white">Pages</Typography>
                        {pages.map((row) => (
                            row == currentPage ? (
                                <Typography className="page-list-item-selected text-white" variant="body2" p={2}>{row}</Typography>
                            ) : (
                                <Typography variant="body2" p={2} className="page-list-item" color="grey" onClick={() => changePage(row)}>{row}</Typography>
                            )

                        ))}
                        <br />
                    </Grid>
                    <Grid bgcolor={'#0F1536'} maxHeight={'70vh'} p={2} borderRadius={2} size={{ lg: 7 }} >
                        <Typography variant="h6" color="white">Headings:</Typography>
                        {/* <br /> */}
                        <form onSubmit={saveChanges}>
                            <Grid mt={2} height="50vh" sx={{ overflowY: "auto" }}>
                                {headings.map((row) => (
                                    <div
                                        key={row.no}
                                        className="mt-2 row m-0 text-white"
                                    >
                                        <h6 className="fw-bold">
                                            Heading #{row.no}
                                        </h6>

                                        <input
                                            type="text"
                                            value={row.content || ""}
                                            onChange={(e) =>
                                                handleChange(row.no, e.target.value)
                                            }
                                            className="w-100 input-content mt-1"
                                        />
                                    </div>
                                ))}
                            </Grid>

                            <button
                                type="submit"
                                className="btn btn-danger mt-3"
                            >
                                Save Changes
                            </button>
                        </form>
                        {/* <Button onClick={() => setst([...st, (st + 1)])} variant="contained"><Add /></Button>
                        <form onSubmit={submit}>
                            {st.map((row, index) => (
                                <Grid display={"flex"}>
                                    <TextField name={"name" + row} fullWidth margin="dense" label="Name" size="small" />
                                    <Button onClick={() => abcd(index)}>
                                        <Close />
                                    </Button>
                                </Grid>
                            ))}
                            <Button type="submit" onClick={() => setst([...st, (st + 1)])} variant="contained"><Add /></Button>
                        </form> */}

                    </Grid>
                </Grid>
            </Grid >

        </>
    )

}